import React, { useCallback } from 'react';
import { NavigationHeaderRightHelpButton } from 'design-system/NavigationHeaderRightTextButton';
import { useMainStackNavigation } from 'utils/types/navigationV6';
const HelpScreenButton = ({ articlesKey, }) => {
    const navigation = useMainStackNavigation();
    const onPress = useCallback(() => {
        navigation.navigate('Help', { articlesKey }, { pop: true });
    }, [navigation, articlesKey]);
    return <NavigationHeaderRightHelpButton onPress={onPress}/>;
};
export default HelpScreenButton;
